// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center-row[data-v-16f5837c]{justify-content:center}.align-row[data-v-16f5837c]{margin:0 80px!important}.fmv-image[data-v-16f5837c]{max-width:255px;height:152px;margin:0 auto 15px;width:100%;overflow:hidden;background-repeat:no-repeat;background-position:50%;background-size:contain;position:relative}", ""]);
// Exports
module.exports = exports;
